import Joi from 'joi-browser';
import { capitalize } from 'lodash';
import React from 'react';
import Form from '../../../common/form';

class PackageUpgradeForm extends Form {
	state = {
		data: {
			securityPassword: '',
			accept: '',
		},
		errors: {},
	};

	schema = {
		securityPassword: Joi.string().required().label('Security Password'),
		accept: Joi.boolean().valid(true).required().label('Accept'),
	};
	doSubmit = () => this.props.onSubmit(this.state.data);

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, hasSP, currentCard, plannerCard } = this.props;

		return (
			<form
				className='row mt-4'
				onSubmit={this.handleSubmit}>
				<div className='col-xl-4 offset-xl-4 col-12 text-start'>
					{this.renderChecks({
						name: 'accept',
						label: (
							<span>
								I want to upgrade my current{' '}
								<b>{capitalize(currentCard.name)} Investor </b>
								card to the <b>{capitalize(plannerCard.name)} Planner</b> package as
								described above.
							</span>
						),
					})}

					{this.renderSubmitBtnWithSPass({
						divClass: 'mb-4 mt-2',
						hasSP,
						isLoading,
						text: 'Upgrade',
						loadingText: 'Upgrading...',
					})}
				</div>
			</form>
		);
	}
}

export default PackageUpgradeForm;
